import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CampaignWebhookSubscriptionDto} from "../../model/dto/entity/campaign-webhook-subscription.dto";

/**
 * Service for CampaignWebhookSubscription entity operations.
 * F-033: Webhook and Event Notifications
 */
@Injectable({
    providedIn: 'root'
})
export class CampaignWebhookSubscriptionService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignWebhookSubscriptions')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-link';
    }

    /**
     * Gets all active subscriptions for a campaign.
     */
    getSubscriptionsByCampaign(campaignId: number): Observable<CampaignWebhookSubscriptionDto[]> {
        return this.getGeneric<CampaignWebhookSubscriptionDto[]>(`/byCampaign/${campaignId}`);
    }
}
